import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import { useCustomTranslation } from 'hooks/useCustomTranslation'
import DepartmentsList from './DepartmentsList/DepartmentsList'
import InnerTitleSection from 'components/InnerTitleSection/InnerTitleSection'
import Loader from 'components/Loader/Loader'

const Departments: React.FC = () => {
  const { t, i18n } = useCustomTranslation()
  const currentLanguage = i18n.language
  const isAr = currentLanguage === 'ar'

  const isLoading = useSelector(
    (state: RootState) => state.department.isLoading
  )

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return isLoading ? (
    <Loader />
  ) : (
    <main>
      <InnerTitleSection
        title={t('navDepartments')}
        breadcrumbs={[
          {
            title: t('navHome'),
            link: `/${currentLanguage}`,
          },
          {
            title: t('navDepartments'),
          },
        ]}
      />
      <DepartmentsList isAr={isAr} t={t} />
    </main>
  )
}

export default Departments
